import { call, put } from 'redux-saga/effects'
import api from './../../../utils/api'
import actions from './../actions'

const queryReport = (reportName, reportOptions) => call(api.getReport, reportName, reportOptions)

function* fetchReport(action) {
  yield put({ type: actions.fetchPending })
  let report
  try {
    report = yield queryReport(action.reportName, action.reportOptions)
  } finally {
    yield put({ type: actions.setReport, report })
  }
}

export default fetchReport



// WEBPACK FOOTER //
// ./src/store/reports/report/saga.js